const ANALYTICS_COOKIES = {
  SessionId: "analyticsSessionId",
  ScreenWidth: "analyticsScreenWidth",
  ScreenHeight: "analyticsScreenHeight",
} as const;

export default ANALYTICS_COOKIES;
